<div class="nuevo-catalogo-container">
  <p class="heading-catalogo">Remitentes y destinatarios</p>
</div>
<form class="search-remitente">
  <div class="search-remitente-container">
    <mat-icon
      aria-hidden="false"
      aria-label="search icon"
      fontIcon="search"></mat-icon>
    <mat-form-field class="search-remitente-input">
      <mat-label>Remitente o destinatario</mat-label>
      <input
        [(ngModel)]="filtroNombre"
        (input)="search($event)"
        type="text"
        matInput
        name="filtroNombre"
        placeholder="Remitente o destinatario" />
    </mat-form-field>
  </div>

  <button
    (click)="newRemitente()"
    mat-mini-fab
    aria-label="Agregar nuevo tipo"
    color="primary">
    <mat-icon>add</mat-icon>
  </button>
</form>
<app-add-remitente [remitentes]="remitentes"></app-add-remitente>

<mat-card-content class="catalog-list" *ngFor="let remitente of remitentes">
  <mat-card class="catalog-card">
    <div
      class="catalog-card-view"
      *ngIf="
        !editandoRegistro ||
        (editandoRegistro && registroSeleccionado !== remitente)
      ">
      <div style="padding: 1rem">
        <p class="catalog-title">
          {{ remitente?.nombre }} {{ remitente?.apellido }}
        </p>
        <p>{{ remitente?.mail }}</p>
      </div>
      <div *ngIf="admonCatRemitenteStatus$ | async as remitenteStatus">
        <mat-card-actions
          align="end"
          class="nuevo-catalogo-actions"
          *ngIf="
            !remitenteStatus.mostrarEditar && !remitenteStatus.mostrarNuevo
          ">
          <button
            class="uppercase-button editar"
            mat-button
            (click)="editarRegistro(remitente)">
            Editar
          </button>
          <button
            class="uppercase-button editar"
            mat-button
            (click)="eliminarRemitente(remitente)">
            Borrar
          </button>
        </mat-card-actions>
      </div>
    </div>
  </mat-card>
  <div *ngIf="admonCatRemitenteStatus$ | async as remitenteStatus">
    <mat-card
      class="catalog-card"
      *ngIf="
        remitenteStatus.mostrarEditar && registroSeleccionado === remitente
      ">
      <div class="catalog-card-header">
        <p class="catalog-title">
          {{ remitente?.nombre }} {{ remitente?.apellido }}
        </p>
        <p>{{ remitente?.mail }}</p>
      </div>
      <div class="catalog-card-edit">
        <form
          [formGroup]="editarForm"
          class="nuevo-catalogo-form !grid !grid-cols-1 !gap-3">
          <mat-form-field class="nuevo-catalogo-field !w-1/2">
            <mat-label>Nombre</mat-label>
            <input
              formControlName="nombre"
              name="nombre"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              [value]="remitente?.nombre"
              placeholder="" />
            <mat-hint align="end"
              >{{ editarForm.get("nombre")?.value.length }} / 50</mat-hint
            >
            @if (editarForm.get('nombre')?.invalid &&
            editarForm.get('nombre')?.touched &&
            !editarForm.get('nombre')?.hasError('nombreRemitente')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (editarForm.get('nombre')?.invalid &&
            editarForm.get('nombre')?.touched &&
            editarForm.get('nombre')?.hasError('nombreRemitente')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="nuevo-catalogo-field !w-1/2">
            <mat-label>Apellidos</mat-label>
            <input
              formControlName="apellido"
              name="apellido"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              [value]="remitente?.apellido"
              placeholder="" />
            <mat-hint align="end"
              >{{ editarForm.get("apellido")?.value.length }} / 50</mat-hint
            >
            @if (editarForm.get('apellido')?.invalid &&
            editarForm.get('apellido')?.touched &&
            !editarForm.get('apellido')?.hasError('nombreRemitente')) {
            <mat-error>Campo obligatorio</mat-error>
            } @if (editarForm.get('apellido')?.invalid &&
            editarForm.get('apellido')?.touched &&
            editarForm.get('apellido')?.hasError('nombreRemitente')) {
            <mat-error>Sólo se permiten letras y espacios.</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="nuevo-catalogo-field !w-1/2">
            <mat-label>Correo electrónico</mat-label>
            <input
              formControlName="mail"
              name="mail"
              class="nuevo-catalogo-input"
              type="text"
              maxlength="50"
              matInput
              [value]="remitente?.mail"
              (input)="existeRegistro(editarForm.get('mail'), remitente?.mail)"
              placeholder="" />
            @if (editarForm.get('mail')?.invalid &&
            editarForm.get('mail')?.touched &&
            !editarForm.get('mail')?.hasError('mailDuplicad@')&&
            !editarForm.get('mail')?.hasError('invalidEmail')) {
            <mat-error>Campo obligatorio</mat-error>
            }

            <mat-error
              *ngIf="
                editarForm.get('mail')?.hasError('mailDuplicad@') &&
                !(editarForm.get('mail')?.value === remitente?.mail)
              ">
              El correo ya se encuentra registrado.
            </mat-error>
            <mat-error *ngIf="editarForm.get('mail')?.hasError('invalidEmail')">
              {{
                " El correo electrónico proporcionado es incorrecto, por favor
           ingréselo en el siguiente formato: usuario/a@dominio Ej:
           ejemplo@dominio.com.mx"
              }}
            </mat-error>
          </mat-form-field>
        </form>
        <mat-card-actions align="end" class="nuevo-catalogo-actions">
          <button
            class="uppercase-button editar"
            mat-button
            (click)="cancelarEdicion()">
            Cancelar
          </button>
          <button
            class="uppercase-button editar"
            mat-button
            [disabled]="editarForm.invalid || existe"
            (click)="guardarCambios(remitente)">
            Guardar
          </button>
        </mat-card-actions>
      </div>
    </mat-card>
  </div>
</mat-card-content>
<br />
